export const routes = [
    {
        context: 'billing',
        method: 'GET',
        path: '/admin/subscriptions',
        operationId: 'Subscriptions_list',
        auth: 'platform-admin',
        action: 'subscription:list',
        tool: 'billing_Subscriptions_list',
        description: 'List tenant subscriptions, optionally by status.',
        pathParams: [],
        queryParams: ['cursor', 'limit', 'status'],
        hasBody: false,
        successStatus: 200,
    },
    {
        context: 'billing',
        method: 'GET',
        path: '/admin/subscriptions/{tenantId}',
        operationId: 'Subscriptions_get',
        auth: 'platform-admin',
        action: 'subscription:read',
        tool: 'billing_Subscriptions_get',
        description: "One tenant's subscription record.",
        pathParams: ['tenantId'],
        queryParams: [],
        hasBody: false,
        successStatus: 200,
    },
    {
        context: 'billing',
        method: 'POST',
        path: '/admin/subscriptions/{tenantId}/adjust',
        operationId: 'Subscriptions_adjust',
        auth: 'platform-admin',
        action: 'subscription:adjust',
        tool: 'billing_Subscriptions_adjust',
        description: "Adjust a tenant's subscription on Stripe: seat quantity, cancel at period end. Audited.",
        pathParams: ['tenantId'],
        queryParams: [],
        hasBody: true,
        successStatus: 200,
    },
    {
        context: 'billing',
        method: 'POST',
        path: '/checkout',
        operationId: 'Checkouts_create',
        auth: 'tenant',
        action: 'checkout:create',
        tool: 'billing_Checkouts_create',
        description: "Create (or resume) a hosted Stripe Checkout Session for the tenant's package. Returns the URL to redirect to.",
        pathParams: [],
        queryParams: [],
        hasBody: true,
        successStatus: 201,
    },
    {
        context: 'billing',
        method: 'POST',
        path: '/portal',
        operationId: 'Portals_create',
        auth: 'tenant',
        action: 'portal:create',
        tool: 'billing_Portals_create',
        description: 'Open a Stripe Customer Portal session for the tenant (payment method, invoices, cancellation).',
        pathParams: [],
        queryParams: [],
        hasBody: true,
        successStatus: 201,
    },
    {
        context: 'billing',
        method: 'GET',
        path: '/summary',
        operationId: 'Summary_get',
        auth: 'tenant',
        action: 'billing:read',
        tool: 'billing_Summary_get',
        description: "The caller's tenant billing state: plan, seats, current period, next and last invoice, portal availability.",
        pathParams: [],
        queryParams: [],
        hasBody: false,
        successStatus: 200,
    },
    {
        context: 'billing',
        method: 'POST',
        path: '/webhook',
        operationId: 'Webhooks_receive',
        auth: 'public',
        action: 'webhook:receive',
        assistantExempt: 'Stripe calls it with a signed body; there is no principal to act as',
        description: 'Stripe webhook endpoint. Authenticated by `Stripe-Signature` over the raw body, idempotent\non `event.id`, tolerant of replays and out-of-order delivery. Returns 200 once the event is\nrecorded (or was already processed), 401 on a bad signature, 400 on an unparseable body.',
        pathParams: [],
        queryParams: [],
        hasBody: true,
        successStatus: 200,
    },
];
//# sourceMappingURL=routes.js.map